
  import Icon from './Icon'
  
  export default {
    name: 'FilterDropdown',
    components: {
      Icon,
    },
    props: {
      dietaryConfig: {
        type: Array,
        required: true,
      },
      lifeStyleConfig: {
        type: Array,
        required: true,
      },
    },
  };
  